type IApiRoutesParams = {
  isNodePayments?: boolean;
  userId?: number;
};

export const apiRoutes = {
  deposit: ({ isNodePayments, userId }: IApiRoutesParams) =>
    isNodePayments
      ? '/service/payments/v1/deposit'
      : `/accounting/api/v1/users/${userId}/payments/deposit`,
  withdraw: ({ isNodePayments, userId }: IApiRoutesParams) =>
    isNodePayments
      ? '/service/payments/v1/withdrawal'
      : `/accounting/api/v1/users/${userId}/payments/withdraw`
};
